<template>
  <div :class="$style.wrapper">
    <div :class="$style.topInner">
      <img v-if="proxyGene" :src="require('./assets/gene.svg')" :class="$style.gene">
      <span :class="$style.title">{{proxyTitle}}</span>
      <WindowСontrolButtons />
    </div>
    <div :class="[$style.inner, miniInner ? $style.minInner : '']">
      <slot />
    </div>
  </div>
</template>
<script>
import WindowСontrolButtons from '@/components/@ui/WindowСontrolButtons/WindowСontrolButtons.vue'

export default {
  name: 'TaskWindow',
  props: {
    title: {
      type: String,
      default: '',
    },
    miniInner: {
      type: Boolean,
      default: false,
    },
    gene: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proxyTitle: this.title,
      proxyGene: this.gene,
    }
  },
  components: {
    WindowСontrolButtons,
  },
  watch: {
    title() {
      this.proxyTitle = this.title
    },
    gene() {
      this.proxyGene = this.gene
    },
  },
}
</script>
<style lang="scss" module>
  @import './TaskWindow.sass';
</style>
